window.toggleTopNavLinks = function() {
  const topNavLinks = document.getElementById('top-nav-links');
  if (topNavLinks.style.display === '') {
    topNavLinks.style.display = 'inherit';
  } else {
    topNavLinks.style.display = '';
  }
};
